
import {
  TERRAIN_TILE_HEIGHT,
  TERRAIN_TILE_WIDTH,
  KELP_N_FRAMES,
  STATIC_N_FRAMES
} from "../../constants"

const KELP_REM        = 20
const KELP_MAX_HEIGHT = 5
const KELP_MIN_HEIGHT = 1
const KELP_SIZE       = 24
const STATIC_REM      = 20
const STATIC_SIZE     = 24

export async function generateGroundObjects ({ offsetY, pixels }) {
  const width = TERRAIN_TILE_WIDTH
  const height = TERRAIN_TILE_HEIGHT

  let groundObjects = []

  const isAttachedToGround = (x, y) => {
    return pixels[(x + y * width) * 4 + 3] == 255
  }
  
  for (let x = 0; x < width; ++ x)
    for (let y = 0; y < height; ++ y) {
      if (   y != 0
	  && pixels[(x + y * width) * 4 + 3]       == 255
	  && pixels[(x + (y - 1) * width) * 4 + 3] == 0) {
	if ((x + 1234) % KELP_REM == 0) {
	  // "KELP"
	  const nSegments = Math.max(
	    Math.ceil(Math.random() * KELP_MAX_HEIGHT),
	    KELP_MIN_HEIGHT)

	  const offset = Math.round((Math.random() * 12) - 6)
	  const startX = x + offset
	  const startY = y

	  if (isAttachedToGround(startX, startY + KELP_SIZE / 2)) {
	    let startFrame = Math.round(Math.random() * (KELP_N_FRAMES - 1))
	    for (let i = 0; i < nSegments; ++ i)
	      groundObjects.push({
		x: startX - width / 2,
		y: startY + offsetY - KELP_SIZE * i - 8,
		animated: true,
		startFrame,
		id: "kelp"
	      })
	    groundObjects[groundObjects.length - 1].id = "kelp-top"
	  }
	}

	if ((x + 4321) % STATIC_REM == 0) {
	  const startX = x
	  const startY = y - 4
	  
	  if (isAttachedToGround(startX, startY + STATIC_SIZE / 2)) {
	    groundObjects.push({
	      x: startX - width / 2,
	      y: startY + offsetY,
	      animated: false,
	      startFrame: Math.round(Math.random() * (STATIC_N_FRAMES - 1)),
	      id: "static"
	    })
	  }
	}
      }
    }

  return groundObjects
}
